import Flickity from './../externals/flickity/wwdevFlickity';
class logoSlider {
	constructor(config) {
		this.config = Object.assign({
			scope: '.logo_slider',
			speed: 1.5
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.each((index, element) => {
			let $scope = $(element);
			let carouselEl = $scope.find('.flickity-carousel')[0];

			$(carouselEl).on('ready.flickity', () => {
				let slider = Flickity.data(carouselEl);
				this.startAnimation(slider, $scope);
			});

			// Fallback als ready al afgevuurd is
			let slider = Flickity.data(carouselEl);
			if (slider) {
				this.startAnimation(slider, $scope);
			}
		});
	}

	startAnimation(slider, $scope) {
		slider.stopPlayer();

		let isPaused = false;
		let speed = this.config.speed || 1;

		const animate = () => {
			if (!isPaused) {
				slider.x -= speed;

				if (Math.abs(slider.x) >= slider.slideableWidth) {
					slider.x += slider.slideableWidth;
				}

				slider.positionSlider();
			}
			requestAnimationFrame(animate);
		};

		requestAnimationFrame(animate);

		$scope.find('.flickity-carousel')
			.on('mouseenter', () => { isPaused = true; })
			.on('mouseleave', () => { isPaused = false; });
	}
}

export default new logoSlider;